//CSS
import "../../Components/Page/Page.css";
import engine from "../../Images/OurStory/Wankel.png";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import ImageComp from "../../Components/ImageContainer/ImageComp";

const WankelStory: React.FC = () => {
    return (
        <div id="Goals" className="sectionContainer">
            <SecHeader title="Wankel Story" />
            <SubSection>
                <ImageComp imageSource={engine} width={"25vw"} />
                <div className="description-container">
                    <p>
                        The Wankel rotary engine and its underlying geometry were patented in 1957, which
                        was the last truly new ICE geometry. Before even building prototypes, Wankel's employer
                        sold 28+ testing licenses to major engine manufacturers, generating over $0.7 billion
                        ($6.3 billion today) over 13 years. The Wankel engine's key advantage was and still
                        is its high power-to-weight ratio, but it had sealing issues.
                    </p>{" "}

                </div>
            </SubSection>


        </div>
    );
};

export default WankelStory;
